/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

export const showErrorText = (
  text: string,
  autoClose: false | number = 2000,
  onClick?: () => void
) =>
  toast.error(text, {
    position: "top-right",
    autoClose,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onClick: onClick || undefined,
  });

const useDetailsNotFound = () => {
  const { replace } = useHistory();

  const detailsNotFound = React.useCallback(
    (route: string, name: string) => {
      showErrorText(`${name} details not found`);
      replace(route);
    },
    [replace]
  );

  return { detailsNotFound };
};

export { useDetailsNotFound };
